import videoBg from '@/image/videoBg.mp4'
import bg5 from '@/image/bg5.svg'
import bg4 from '@/image/bg4.png'
import { useState, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import img7 from '@/image/img7.png'
import ScrollView from '@/components/ScrollView'
import bg7 from '@/image/bg7.svg'
import bg10 from '@/image/bg10.svg'
import bg11 from '@/image/bg11.svg'
import bg12 from '@/image/bg12.svg'
// import bg13 from '@/image/bg13.svg'
import bg18 from '@/image/bg18.svg'
import FFR from '@/image/logo/FFR.svg'
import FIBO from '@/image/logo/FIBO.svg'
import OKEX from '@/image/logo/OKEX.svg'
import TP from '@/image/logo/TP.svg'
import AVE from '@/image/logo/AVE.svg'
import BINANCE from '@/image/logo/BINANCE.svg'
import CERTIK from '@/image/logo/CERTIK.svg'
import PANCAKESWAP from '@/image/logo/PANCAKESWAP.svg'
import GATE from '@/image/logo/GATE.svg'
import DEXTOOLS from '@/image/logo/DEXTOOLS.svg'
import telegram from '@/image/telegram.svg'
import earth from '@/image/earth.svg'
import RosePieChart from './conpoment/RosePieChart'
import { DiscordOutlined, XOutlined } from '@ant-design/icons'
import Icon from '@/components/Icon'
import { CONTACT_LINK } from '@/collocate'
const logo = [
  { img: GATE, value: "Gate.io", w: '', },
  { img: FIBO, value: "FIBONACCI", w: ' ' },
  { img: BINANCE, value: "BINANCE", w: '' },
  { img: TP, value: "TOKENPOCKET", w: '!text-10px' },
  { img: OKEX, value: "OKEX", w: '' },
  { img: FFR, value: "FFR", w: '' },
  { img: PANCAKESWAP, value: "PancakeSwap", w: '' },
  { img: CERTIK, value: "CERTIK", w: '' },
  { img: AVE, value: "AVE", w: '' },
  { img: DEXTOOLS, value: "DEXTOOLS", w: '' }
]
const leftpx = [
  { zh: 'left-[40px]', en: 'left-[30px]', ja: "left-[50px]", ko: "left-[70px]" },
  { zh: 'left-[210px]', en: 'left-[210px]', ja: "left-[235px]", ko: "left-[245px]" },
  { zh: 'left-[385px]', en: 'left-[385px]', ja: "left-[410px]", ko: "left-[415px]" },
  { zh: 'left-[575px]', en: 'left-[575px]', ja: "left-[605px]", ko: "left-[615px]" },
  { zh: 'left-[755px]', en: 'left-[760px]', ja: "left-[790px]", ko: "left-[790px]" },
  { zh: 'right-[85px]', en: 'right-[125px]', ja: "right-[135px]", ko: "right-[155px]" },

] as const
// const Home = () => {
//   const [videoLoaded, setVideoLoaded] = useState(false)
//   const scrollRef = useRef<HTMLDivElement>(null)
//   const { t, i18n } = useTranslation()
//   const contractPowerData = [
//     { range: t('home.period30'), monthly: '200-1000', yearly: '3 T' },
//     { range: t('home.period90'), monthly: '200-5000', yearly: '6 T' },
//     { range: t('home.period180'), monthly: '200-10000', yearly: '8 T' },
//     { range: t('home.period360'), monthly: '200-20000', yearly: '10 T' },
//     { range: t('home.period720'), monthly: '200-30000', yearly: '15 T' },
//   ]

//   useEffect(() => {
//     const scrollContainer = scrollRef.current
//     if (!scrollContainer) return

//     let interval: NodeJS.Timeout

//     // 延迟执行，等待图片加载完成
//     const timer = setTimeout(() => {
//       // 检查屏幕宽度，如果大于1200px就不滚动
//       if (window.innerWidth >= 1200) return

//       let direction = 1 // 1 表示向右滚动，-1 表示向左滚动

//       const scroll = () => {
//         const maxScroll = scrollContainer.scrollWidth - scrollContainer.clientWidth
//         const currentScroll = scrollContainer.scrollLeft

//         // 到达右边界，改变方向向左
//         if (currentScroll >= maxScroll - 2 && direction === 1) {
//           direction = -1
//         }
//         // 到达左边界，改变方向向右
//         else if (currentScroll <= 2 && direction === -1) {
//           direction = 1
//         }

//         scrollContainer.scrollLeft += direction
//       }

//       interval = setInterval(scroll, 30)
//     }, 1000)

//     return () => {
//       clearTimeout(timer)
//       if (interval) clearInterval(interval)
//     }
//   }, [])

//   return (
//     <ScrollView className="relative text-white " px={'8rem'}>
//       <div className="relative -z-50 top-0 left-0 w-full min-h-[400px] md:min-h-[900px] lg:min-h-[800px]">
//         {/* 内容1 */}
//         <div className='relative z-10  md:max-w-[1200px] lg:max-w-[1400px] xl:max-w-[1600px] mx-auto px-10 md:px-16 lg:px-24 xl:px-28 pt-8 md:pt-24 lg:pt-40 pb-20 md:pb-16 lg:pb-20'>
//           <div className='pb-8'>
//             <div className='text-3xl font-bold bg-gradient-to-r from-white to-d5a bg-clip-text text-transparent inline-block'>{t('home.mainTitle')}</div>
//             <div />
//             <div className='font-mono text-base font-bold bg-gradient-to-r from-white to-d5a bg-clip-text text-transparent inline-block'>{t('home.mainSubtitle')}</div>
//           </div>
//           <div className='flex items-center md:items-start text-d5a mt-16'>
//             <div className='xx mr-3 md:mr-5 lg:mr-6 flex-shrink-0' />
//             <div className='text-sm md:text-base lg:text-lg xl:text-xl space-y-4 md:space-y-5 lg:space-y-6'>
//               <div className='flex items-center'>
//                 <img src={img7} alt="" className='w-4 md:w-5 mr-2  lg:w-6 md:mr-3 lg:mr-4 flex-shrink-0' />
//                 <span>{t('home.feature1')}</span>
//               </div>
//               <div className='flex items-center'>
//                 <img src={img7} alt="" className='w-4 md:w-5 lg:w-6 mr-2 md:mr-3 lg:mr-4 flex-shrink-0' />
//                 <span>{t('home.feature2')}</span>
//               </div>
//               <div className='flex items-center'>
//                 <img src={img7} alt="" className='w-4 md:w-5 lg:w-6 mr-2 md:mr-3 lg:mr-4 flex-shrink-0' />
//                 <span>{t('home.feature3')}</span>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* 背景视频层 */}
//         <div className='absolute h-full w-full top-0 left-0 overflow-hidden'>
//           <div className='absolute -z-30 top-0 left-0 h-full w-full cs' />
//           <img src={bg4} className='absolute -z-40 left-0 top-0 w-full h-full object-cover' alt="" />
//           {!videoLoaded && (
//             <div className='absolute top-0 left-0 w-full h-full -z-40 bg-black'>
//               <img src={bg5} className='w-full h-full object-cover opacity-60' alt="" />
//             </div>
//           )}
//           <video
//             src={videoBg}
//             autoPlay
//             loop
//             muted
//             playsInline
//             className='-z-50 absolute top-0 left-0 w-full h-full object-cover'
//             onCanPlay={() => setVideoLoaded(true)}
//             onLoadedData={() => setVideoLoaded(true)}
//           />
//         </div>
//       </div>

//       {/* 内容2 - 项目介绍 */}
//       <div className='relative    md:max-w-[1200px] lg:max-w-[1400px] xl:max-w-[1600px] mx-auto px-10 md:px-16 lg:px-24 xl:px-28 mb-4 md:mb-16 lg:mb-20'>
//         <div className='relative'>
//           <p className='text-sm md:text-base lg:text-lg leading-loose md:leading-loose lg:leading-loose text-gray-300/90'>
//             {t('home.description')}
//           </p>
//         </div>
//       </div>

//       {/* 内容3 - 区块链与AI深度融合 */}
//       <div className='relative py-12 md:py-16 lg:py-20 mb-3 md:mb-16 lg:mb-20 overflow-hidden'>

//         <div className='relative max-w-[1200px] lg:max-w-[1400px] xl:max-w-[1600px] mx-auto px-10 md:px-16 lg:px-24 xl:px-28'>
//           {/* 分为三张卡片：概述 / 三大价值 / 未来展望（含指示器） */}
//           <div className='grid grid-cols-1 md:grid-cols-3 gap-6'>
//             {/* 卡片 1 - 概述 */}
//             <div className='relative bg-gradient-to-br from-purple-900/30 via-blue-900/20 to-transparent backdrop-blur-xl border border-purple-900 rounded-2xl p-6 md:p-8  shadow-[0_4px_24px_0_rgba(173,80,255,0.8)]'>
//               <div className='mb-4 flex items-center gap-3'>
//                 <div className='w-1 h-6 bg-gradient-to-b from-purple-500 to-cyan-500 rounded-full'></div>
//                 <h3 className='text-base md:text-lg font-mono font-semibold text-white'>{t('home.blockchainAiTitle')}</h3>
//               </div>
//               <p className='text-sm md:text-base text-gray-300/90 leading-loose' style={{ animation: 'fadeInUp 0.5s ease-out 0s both' }}>{t('home.blockchainAiDesc')}</p>
//             </div>

//             {/* 卡片 2 - 三大核心价值 */}
//             <div className='relative bg-gradient-to-br from-purple-900/30 via-blue-900/20 to-transparent backdrop-blur-xl border border-purple-900 rounded-2xl p-6 md:p-8  shadow-[0_4px_24px_0_rgba(173,80,255,0.8)]'>
//               <h3 className='text-base md:text-lg font-semibold text-white mb-4 flex items-center gap-2'>
//                 <div className='w-1.5 h-1.5 bg-blue-400 rounded-full'></div>
//                 {t('home.coreValuesTitle')}
//               </h3>
//               <div className='space-y-4'>
//                 <div className='pl-4 border-l-2 border-purple-500/20'>
//                   <div className='font-semibold text-white text-sm md:text-base'>{t('home.synergyTitle')}</div>
//                   <div className='text-gray-300/90 text-sm'>{t('home.synergyDesc')}</div>
//                 </div>
//                 <div className='pl-4 border-l-2 border-blue-500/20'>
//                   <div className='font-semibold text-white text-sm md:text-base'>{t('home.industryTitle')}</div>
//                   <div className='text-gray-300/90 text-sm'>{t('home.industryDesc')}</div>
//                 </div>
//                 <div className='pl-4 border-l-2 border-cyan-500/20'>
//                   <div className='font-semibold text-white text-sm md:text-base'>{t('home.trustFutureTitle')}</div>
//                   <div className='text-gray-300/90 text-sm'>{t('home.trustFutureDesc')}</div>
//                 </div>
//               </div>
//             </div>

//             {/* 卡片 3 - 未来展望 + 指示器 */}
//             <div className='relative bg-gradient-to-br from-purple-900/30 via-blue-900/20 to-transparent backdrop-blur-xl border border-purple-900 rounded-2xl p-6 md:p-8  shadow-[0_4px_24px_0_rgba(173,80,255,0.8)]'>
//               <h3 className='text-base md:text-lg font-semibold text-white mb-4 flex items-center gap-2'>
//                 <div className='w-1.5 h-1.5 bg-cyan-400 rounded-full'></div>
//                 {t('home.futureVisionTitle')}
//               </h3>
//               <div className='grid grid-cols-1 gap-3 text-xs md:text-sm text-gray-300/80 leading-relaxed mb-6'>
//                 <div className='flex items-start gap-2'><span className='text-purple-400'>●</span><span>{t('home.vision1')}</span></div>
//                 <div className='flex items-start gap-2'><span className='text-blue-400'>●</span><span>{t('home.vision2')}</span></div>
//                 <div className='flex items-start gap-2'><span className='text-cyan-400'>●</span><span>{t('home.vision3')}</span></div>
//                 <div className='flex items-start gap-2'><span className='text-indigo-400'>●</span><span>{t('home.vision4')}</span></div>
//               </div>

//               <div className='flex items-center gap-6 mt-2 pt-2 border-t border-white/6'>
//                 <div className='flex items-center gap-2'>
//                   <div className='w-2 h-2 bg-purple-400 rounded-full animate-pulse'></div>
//                   <span className='text-xs text-purple-300/70'>BlockChain</span>
//                 </div>
//                 <div className='flex items-center gap-2'>
//                   <div className='w-2 h-2 bg-blue-400 rounded-full animate-pulse' style={{ animationDelay: '0.5s' }}></div>
//                   <span className='text-xs text-blue-300/70'>AI</span>
//                 </div>
//                 <div className='flex items-center gap-2'>
//                   <div className='w-2 h-2 bg-cyan-400 rounded-full animate-pulse' style={{ animationDelay: '1s' }}></div>
//                   <span className='text-xs text-cyan-300/70'>RWA</span>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* 新增：Alpha 区块链简介（优化版：更精炼、可读性更好） */}
//           <div className='mt-12'>
//             <div className='relative bg-gradient-to-br from-purple-900/30 via-blue-900/16 to-transparent backdrop-blur-xl border border-purple-900 rounded-2xl p-6 md:p-8  shadow-[0_4px_24px_0_rgba(173,80,255,0.8)]' style={{ animation: 'fadeInUp 0.45s ease-out both' }}>
//               <div className='mb-6'>
//                 <div className='w-14 h-1 rounded-full bg-gradient-to-r from-purple-400 to-cyan-400 mb-3'></div>
//                 <h4 className='text-lg md:text-xl font-semibold text-white'>{t('home.alphaIntroTitle')}</h4>
//               </div>

//               <div className='grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8'>
//                 {/* 左侧：简介 */}
//                 <div>
//                   <p className='text-sm text-gray-300/90 leading-relaxed mb-2'>{t('home.alphaIntroDescShort')}</p>
//                   <p className='text-xs text-gray-400'>{t('home.alphaIntroNote')}</p>
//                 </div>

//                 {/* 右侧：核心特点 */}
//                 <div>
//                   <h5 className='text-base md:text-lg font-semibold text-white mb-4'>{t('home.alphaTokenTitle')}</h5>
//                   <div className='space-y-2'>
//                     <div className='flex items-start gap-3'>
//                       <div className='w-2 h-2 bg-purple-400 rounded-full flex-shrink-0 mt-1'></div>
//                       <div className='text-sm text-gray-300/90 leading-relaxed'>{t('home.alphaFeature1')}</div>
//                     </div>

//                     <div className='flex items-start gap-3'>
//                       <div className='w-2 h-2 bg-yellow-400 rounded-full flex-shrink-0 mt-1'></div>
//                       <div className='text-sm text-gray-300/90 leading-relaxed'>{t('home.alphaFeature2')}</div>
//                     </div>

//                     <div className='flex items-start gap-3'>
//                       <div className='w-2 h-2 bg-indigo-400 rounded-full flex-shrink-0 mt-1'></div>
//                       <div className='text-sm text-gray-300/90 leading-relaxed'>{t('home.alphaFeature3')}</div>
//                     </div>

//                     <div className='flex items-start gap-3'>
//                       <div className='w-2 h-2 bg-pink-400 rounded-full flex-shrink-0 mt-1'></div>
//                       <div className='text-sm text-gray-300/90 leading-relaxed'>{t('home.alphaFeature4')}</div>
//                     </div>

//                     <div className='flex items-start gap-3'>
//                       <div className='w-2 h-2 bg-cyan-400 rounded-full flex-shrink-0 mt-1'></div>
//                       <div className='text-sm text-gray-300/90 leading-relaxed'>{t('home.alphaFeature5')}</div>
//                     </div>

//                     <div className='flex items-start gap-3'>
//                       <div className='w-2 h-2 bg-green-400 rounded-full flex-shrink-0 mt-1'></div>
//                       <div className='text-sm text-gray-300/90 leading-relaxed'>{t('home.alphaFeature6')}</div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>


//       {/* border-purple-900 rounded-2xl p-6 md:p-8  shadow-[0_4px_24px_0_rgba(173,80,255,0.8)] */}
//       <div className='relative mb-3 md:mb-20 mx-10 md:mx-16 lg:mx-24 xl:mx-auto max-w-[1200px] lg:max-w-[1400px] xl:max-w-[1600px] group perspective-[2000px]'>
//         {/* 3D 悬浮光效和阴影 - 简化效果 */}
//         <div className='absolute -inset-4 bg-gradient-to-r from-purple-500/10 via-purple-500/15 to-cyan-500/10 rounded-3xl blur-2xl opacity-60 transition-opacity duration-700'></div>

//         <div className='relative bg-gradient-to-br from-purple-900/30 via-blue-900/20 to-transparent backdrop-blur-xl border border-purple-500/30 rounded-2xl p-8 md:p-10 lg:p-12 overflow-hidden transform-gpu transition-all duration-500 shadow-[0_4px_24px_0_rgba(173,80,255,0.3)]'>
//           {/* 背景装饰 */}
//           <div className='absolute top-0 left-0 w-64 h-64 bg-purple-500/5 rounded-full blur-3xl'></div>
//           <div className='absolute bottom-0 right-0 w-64 h-64 bg-cyan-500/5 rounded-full blur-3xl'></div>

//           {/* 角落装饰 */}
//           <img src={bg7} className='absolute -right-0 -top-0 opacity-50' alt="" />
//           <img src={bg10} className='absolute -left-0 -top-0 opacity-50' alt="" />
//           <img src={bg11} className='absolute -left-0 -bottom-0 opacity-50' alt="" />
//           <img src={bg12} className='absolute -right-0 -bottom-0 opacity-50' alt="" />

//           <div className='relative z-10'>


//             {/* 标题 */}
//             <div className='flex items-center gap-3 mb-6 md:mb-8'>
//               <div className='w-1 h-6 md:h-8 bg-gradient-to-b from-purple-500 to-cyan-500 rounded-full'></div>
//               <h3 className='text-lg md:text-xl lg:text-2xl font-mono font-semibold text-transparent bg-gradient-to-r text-white'>
//                 {t('home.contractHashPower')}
//               </h3>
//             </div>

//             {/* 表格 */}
//             <div className='space-y-2'>
//               {/* 表头 */}
//               <div className='flex items-center justify-between bg-gradient-to-r from-purple-500/10 to-blue-500/10 border border-purple-500/20 rounded-lg px-6 md:px-8 lg:px-10 py-4 md:py-5'>
//                 <div className='w-[40%] text-xs md:text-sm font-medium text-purple-300'>{t('home.contractHashPowerLabel')}(NFX)</div>
//                 <div className='w-[30%] text-center text-xs md:text-sm font-medium text-blue-300'>{t('home.stakingPeriod')}</div>
//                 <div className='w-[30%] text-right text-xs md:text-sm font-medium text-cyan-300'>{t('home.hashPowerRate')}</div>
//               </div>

//               {/* 表格行 */}
//               {contractPowerData.map((item, index) => (
//                 <div
//                   key={index}
//                   className='flex items-center justify-between bg-white/[0.02] hover:bg-white/[0.05] border border-white/10 hover:border-purple-500/30 rounded-lg px-6 md:px-8 lg:px-10 py-4 md:py-5 transition-all duration-300 group/row'
//                   style={{ animation: `slideInRight 0.5s ease-out ${index * 0.1}s both` }}
//                 >
//                   <div className='w-[40%] text-xs md:text-sm text-gray-300 group-hover/row:text-white transition-colors'>{item.monthly}</div>
//                   <div className='w-[30%] text-center text-xs md:text-sm font-mono text-blue-400 group-hover/row:text-blue-300 transition-colors'>{item.range}</div>
//                   <div className='w-[30%] text-right text-xs md:text-sm font-mono text-cyan-400 group-hover/row:text-cyan-300 transition-colors'>{item.yearly}</div>

//                   {/* 悬浮指示器 */}
//                   <div className='absolute left-0 top-1/2 -translate-y-1/2 w-1 h-0 group-hover/row:h-full bg-gradient-to-b from-purple-500 to-cyan-500 rounded-r-full transition-all duration-300'></div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className='relative pt-12 md:py-16 lg:py-20 mb-3 md:mb-16 lg:mb-20 overflow-visible perspective-[2000px]'>
//         <div className='relative max-w-[1200px] lg:max-w-[1400px] xl:max-w-[1600px] mx-auto px-10 md:px-16 lg:px-24 xl:px-28'>
//           {/* 外层卡片容器 */}
//           <div className='relative group/card'>
//             {/* 3D 悬浮光效和阴影 - 简化效果 */}

//             <div className='relative bg-gradient-to-br from-blue-900/30 via-purple-900/20 to-transparent backdrop-blur-xl border border-blue-500/30 rounded-2xl p-8 md:p-12 lg:p-16  md:pt-20 lg:pt-24 overflow-visible transform-gpu transition-all duration-500 shadow-[0_4px_24px_0_rgba(173,80,255,0.3)]'>


//               {/* 角落装饰 */}
//               <div className='absolute top-0 left-0 w-20 h-20 border-t-2 border-l-2 border-blue-500/40 rounded-tl-2xl'></div>
//               <div className='absolute bottom-0 right-0 w-20 h-20 border-b-2 border-r-2 border-purple-500/40 rounded-br-2xl'></div>

//               <div className='relative z-10'>
//                 <div className='flex flex-col items-center justify-center gap-6 md:gap-20 lg:gap-24 transform-gpu'>
//                   {/* 放大的饼图 */}
//                   <div className='relative scale-125 md:scale-150 lg:scale-[1.8] origin-center group/chart'>
//                     <img src={bg13} className='w-36  drop-shadow-2xl' alt="" />
//                   </div>
//                   {/* 数据列表 - 带点的段落形式 */}
//                   <div className='flex items-center group/list relative ml-11'>
//                     <div className='w-full max-w-4xl space-y-3 transform-gpu transition-all duration-500 relative z-10' style={{ transformStyle: 'preserve-3d' }}>
//                       <div className='flex items-center gap-3 text-white text-sm md:text-base' style={{ animation: 'fadeInUp 0.5s ease-out 0s both' }}>
//                         <div className='w-2 h-2 bg-green-500 rounded-full flex-shrink-0 animate-pulse'></div>
//                         <span>{t('home.gateExchange1')}: 30,000,000</span>
//                       </div>

//                       <div className='flex items-center gap-3 text-white text-sm md:text-base' style={{ animation: 'fadeInUp 0.5s ease-out 0.1s both' }}>
//                         <div className='w-2 h-2 bg-blue-500 rounded-full flex-shrink-0 animate-pulse' style={{ animationDelay: '0.2s' }}></div>
//                         <span>{t('home.liquidityT1')}: 20,000,000</span>
//                       </div>

//                       <div className='flex items-center gap-3 text-white text-sm md:text-base' style={{ animation: 'fadeInUp 0.5s ease-out 0.2s both' }}>
//                         <div className='w-2 h-2 bg-orange-400 rounded-full flex-shrink-0 animate-pulse' style={{ animationDelay: '0.4s' }}></div>
//                         <span>{t('home.liquidityT2')}: 20,000,000</span>
//                       </div>

//                       <div className='flex items-center gap-3 text-white text-sm md:text-base' style={{ animation: 'fadeInUp 0.5s ease-out 0.3s both' }}>
//                         <div className='w-2 h-2 bg-yellow-400 rounded-full flex-shrink-0 animate-pulse' style={{ animationDelay: '0.6s' }}></div>
//                         <span>{t('home.privateEquity')}: 30,000,000</span>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className='relative pt-12 md:py-16 lg:py-20  md:mb-16 lg:mb-20 overflow-hidden'>
//         {/* 标题 */}
//         <div className='max-w-[1200px] lg:max-w-[1400px] xl:max-w-[1600px] mx-auto px-10 md:px-16 lg:px-24 xl:px-28 mb-8 md:mb-12'>
//           <div className='flex items-center gap-3'>
//             <div className='w-1 h-6 md:h-8 bg-gradient-to-b from-purple-500 to-cyan-500 rounded-full'></div>
//             <h2 className='text-lg md:text-xl lg:text-2xl font-mono font-semibold text-transparent bg-gradient-to-r text-white '>
//               {t('home.roadmapTitle')}
//             </h2>
//           </div>
//         </div>
//         {/* 路线图容器 */}
//         <div className='relative'>
//           {/* 左右渐变遮罩 */}
//           <div className='absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-black/50 to-transparent z-10 xl:hidden pointer-events-none'></div>
//           <div className='absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-black/50 to-transparent z-10 xl:hidden pointer-events-none'></div>

//           <div ref={scrollRef} className='overflow-x-auto pt-5 pb-2 scrollbar-none flex xl:justify-center'>
//             <div className='flex relative group'>
//               {/* 路线图主体 - 添加发光效果 */}
//               <div className='relative'>
//                 <div className='absolute -inset-2 bg-gradient-to-r  rounded-lg blur-xl opacity-0 transition-opacity duration-700'></div>
//                 <img src={bg18} className='relative w-[1200px] min-w-[1200px] flex-shrink-0 drop-shadow-2xl' alt="" />
//               </div>
//               <div>
//                 <div className={`absolute ${i18n.language !== 'zh' ? 'left-[105px]' : 'left-[98px]'}  top-[2px] font-semibold`}>
//                   {t('home.phase1')}
//                 </div>
//                 <ul className={`list-disc pl-4 absolute  ${leftpx[0][i18n.language as 'zh' | 'en']}  bottom-[40px] tracking-[1px] leading-5  text-ad  text-xs`}>
//                   <li>{t('home.phase1Item1')}</li>
//                   <li>{t('home.phase1Item2')}</li>
//                 </ul>
//                 <div className={`absolute  ${i18n.language !== 'zh' ? 'left-[275px]' : 'left-[268px]'}  bottom-[39px] font-semibold text-66`}>
//                   {t('home.phase2')}
//                 </div>
//                 <ul className={`list-disc pl-4 absolute ${leftpx[1][i18n.language as 'zh' | 'en']} top-[-5px] tracking-[1px] leading-5 text-xs text-ad`}>
//                   <li>{t('home.phase2Item1')}</li>
//                   <li>{t('home.phase2Item2')}</li>
//                   <li>{t('home.phase2Item3')}</li>
//                 </ul>

//                 <div className={`absolute ${i18n.language !== 'zh' ? 'left-[453px]' : 'left-[444px]'} top-[2px] font-semibold `}>
//                   {t('home.phase3')}
//                 </div>

//                 <ul className={`list-disc pl-4 absolute ${leftpx[2][i18n.language as 'zh' | 'en']}  bottom-[40px] tracking-[1px] leading-5 text-xs text-ad`}>
//                   <li>{t('home.phase3Item1')}</li>
//                   <li>{t('home.phase3Item2')}</li>
//                 </ul>

//                 <div className={`absolute  ${i18n.language !== 'zh' ? 'left-[645px]' : 'left-[637px]'}  bottom-[39px] font-semibold text-66`}>
//                   {t('home.phase4')}
//                 </div>
//                 <ul className={`list-disc pl-4 absolute ${leftpx[3][i18n.language as 'zh' | 'en']}  top-[20px] tracking-[1px] leading-5 text-xs text-ad`}>
//                   <li>{t('home.phase4Item1')}</li>
//                   <li>{t('home.phase4Item2')}</li>
//                 </ul>

//                 <div className={`absolute  ${i18n.language !== 'zh' ? 'left-[820px]' : 'left-[810px]'}  top-[2px] font-semibold`}>
//                   {t('home.phase5')}
//                 </div>
//                 <ul className={`list-disc pl-4 absolute ${leftpx[4][i18n.language as 'zh' | 'en']}  bottom-[20px] tracking-[1px] leading-5 text-xs text-ad`}>
//                   <li>{t('home.phase5Item1')}</li>
//                   <li>{t('home.phase5Item2')}</li>
//                   <li>{t('home.phase5Item3')}</li>
//                 </ul>
//                 <div className={`absolute   ${i18n.language !== 'zh' ? 'right-[175px]' : 'right-[165px]'}  bottom-[39px] font-semibold text-66 `}>
//                   {t('home.phase6')}
//                 </div>
//                 <ul className={`list-disc pl-4 absolute ${leftpx[5][i18n.language as 'zh' | 'en']}   -top-[5px] tracking-[1px] leading-5 text-xs text-ad`}>
//                   <li>{t('home.phase6Item1')}</li>
//                   <li>{t('home.phase6Item2')}</li>
//                   <li>{t('home.phase6Item3')}</li>
//                 </ul>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* logo区域 */}
//       <div className='relative py-12 md:py-16 lg:py-20 mb-12 md:mb-16 lg:mb-20 overflow-hidden'>
//         {/* 背景装饰 */}
//         <div className='absolute inset-0 bg-gradient-to-br from-purple-900/10 via-transparent to-blue-900/10'></div>
//         <div className='absolute bottom-0 right-0 w-96 h-96 bg-purple-500/10 rounded-full blur-[150px]'></div>

//         <div className='relative max-w-[1200px] lg:max-w-[1400px] xl:max-w-[1600px] mx-auto px-10 md:px-16 lg:px-24 xl:px-28'>
//           {/* 标题 */}
//           <div className='flex items-center justify-center gap-3 mb-8 md:mb-10'>
//             <div className='w-1 h-6 md:h-8 bg-gradient-to-b from-purple-500 to-cyan-500 rounded-full'></div>
//             <h2 className='text-lg md:text-xl lg:text-2xl font-mono font-semibold text-transparent bg-gradient-to-r text-white bg-clip-text'>
//               {t('home.partners')}
//             </h2>
//             <div className='w-1 h-6 md:h-8 bg-gradient-to-b from-cyan-500 to-purple-500 rounded-full'></div>
//           </div>
//           <div className='grid grid-cols-2 md:grid-cols-2 gap-4 md:gap-6 lg:gap-8 max-w-2xl mx-auto'>
//             {
//               logo.map((logoItem, index) => (
//                 <div
//                   key={index}
//                   className={`relative bg-white/[0.02] hover:bg-white/[0.05] border border-white/10 rounded-lg w-full h-16 md:h-20 lg:h-24 flex items-center px-2  transition-all duration-300 shadow-[0_24px_48px_rgba(0,0,0,0.25),0_6px_18px_rgba(0,0,0,0.12),0_0_40px_rgba(255,255,255,0.04)]`}
//                   style={{ animation: `fadeInUp 0.5s ease-out ${index * 0.08}s both` }}
//                 >
//                   <img src={logoItem.img} alt="" className={`${logoItem.w} transition-all duration-300`} />

//                   {/* 悬浮光效 */}
//                   <div className='absolute inset-0 bg-gradient-to-br from-purple-500/0 via-blue-500/0 to-cyan-500/0 rounded-lg transition-all duration-500'></div>

//                   {/* 底部阴影（静态） */}
//                   <div className='absolute -bottom-2 left-1/2 -translate-x-1/2 w-3/4 h-2 bg-purple-500/5 blur-lg rounded-full transition-all duration-300'></div>
//                 </div>
//               ))
//             }
//           </div>
//         </div>
//       </div>
//     </ScrollView >
//   )
// }

const Home = () => {
  const { t, i18n: { language } } = useTranslation()
  const [videoLoaded, setVideoLoaded] = useState(false)
  const contractPowerData = [
    { range: t('home.period30'), monthly: '200-1000', yearly: '3 T' },
    { range: t('home.period90'), monthly: '200-5000', yearly: '6 T' },
    { range: t('home.period180'), monthly: '200-10000', yearly: '8 T' },
    { range: t('home.period360'), monthly: '200-20000', yearly: '10 T' },
    { range: t('home.period720'), monthly: '200-30000', yearly: '15 T' },
  ]
  const scrollRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    const scrollContainer = scrollRef.current
    if (!scrollContainer) return

    let interval: NodeJS.Timeout

    // 延迟执行，等待图片加载完成
    const timer = setTimeout(() => {
      // 检查屏幕宽度，如果大于1200px就不滚动
      if (window.innerWidth >= 1200) return

      let direction = 1 // 1 表示向右滚动，-1 表示向左滚动

      const scroll = () => {
        const maxScroll = scrollContainer.scrollWidth - scrollContainer.clientWidth
        const currentScroll = scrollContainer.scrollLeft

        // 到达右边界，改变方向向左
        if (currentScroll >= maxScroll - 2 && direction === 1) {
          direction = -1
        }
        // 到达左边界，改变方向向右
        else if (currentScroll <= 2 && direction === -1) {
          direction = 1
        }

        scrollContainer.scrollLeft += direction
      }

      interval = setInterval(scroll, 30)
    }, 1000)

    return () => {
      clearTimeout(timer)
      if (interval) clearInterval(interval)
    }
  }, [])
  return (
    <ScrollView className="text-white " px={'8.1rem'}>
      {/* 第一部分内容 */}
      <div className='relative pt-8 md:pt-24 min-h-[350px] md:min-h-[900px]  '>
        {/* 背景视频层 */}
        <div className='absolute  top-0 left-0 overflow-hidden w-full h-full'>
          <div className='absolute -z-30 top-0 left-0 h-full w-full cs' />
          <img src={bg4} className='absolute -z-40 left-0 top-0 w-full h-full object-cover' alt="" />
          {!videoLoaded && (
            <div className='absolute top-0 left-0 w-full h-full -z-40 bg-black'>
              <img src={bg5} className='w-full h-full object-cover opacity-60' alt="" />
            </div>
          )}
          <video
            src={videoBg}
            autoPlay
            loop
            muted
            playsInline
            className='-z-50 absolute top-0 left-0 w-full h-full object-cover'
            onCanPlay={() => setVideoLoaded(true)}
            onLoadedData={() => setVideoLoaded(true)}
          />
        </div>
        {/* 视频上面的内容 */}
        <div className='relative -z-10  mx-10  max-w-[1200px] md:mx-auto '>
          {/* 标题 */}
          <div className='text-3xl font-bold bg-gradient-to-r from-white to-d5a bg-clip-text text-transparent inline-block'>{t('home.mainTitle')}</div>
          <div />
          {language !== 'en' && <div className='font-mono text-base font-bold bg-gradient-to-r from-white to-d5a bg-clip-text text-transparent inline-block'>{t('home.mainSubtitle')}</div>}
          {/* 小标题 */}
          <div className='flex items-center md:items-start text-d5a mt-24'>
            {/* 颜色渐变的边 */}
            <div className='xx mr-3 md:mr-5' />
            {/* 标题 */}
            <div className='text-sm md:text-base '>
              <div className='flex items-center'>
                <img src={img7} alt="" className='w-4 mr-2  md:w-5 md:mr-3 ' />
                <span>{t('home.feature1')}</span>
              </div>
              <div className='flex items-center mt-4'>
                <img src={img7} alt="" className='w-4 mr-2  md:w-5 md:mr-3 ' />
                <span>{t('home.feature2')}</span>
              </div>
              <div className='flex items-center mt-4'>
                <img src={img7} alt="" className='w-4 mr-2  md:w-5 md:mr-3 ' />
                <span>{t('home.feature3')}</span>
              </div>
            </div>
          </div>
        </div>

      </div>

      {/* 第二部分 */}
      <p className='text-sm  leading-loose text-gray-300/90 mx-10   md:px-16   md:max-w-[1200px]   md:text-base  md:mx-auto'>
        {t('home.description')}
      </p>

      {/* 第三部分 */}
      <div className='mx-10 mt-12 md:max-w-[1200px] md:mx-auto'>
        {/* 第一个卡片 */}
        <div className='  bg-gradient-to-br from-purple-900/30 via-blue-900/20 to-transparent border border-purple-900 rounded-2xl p-6  shadow-[0_4px_24px_0_rgba(173,80,255,0.8)] md:p-8'>
          <div className='mb-4 flex items-center gap-3'>
            <div className='w-1 h-6 bg-gradient-to-b from-purple-500 to-cyan-500 rounded-full'></div>
            <h3 className='text-lg md:text-lg font-mono font-semibold text-white'>{t('home.blockchainAiTitle')}</h3>
          </div>
          <p className='text-sm md:text-base text-gray-300/90 leading-loose' style={{ animation: 'fadeInUp 0.5s ease-out 0s both' }}>{t('home.blockchainAiDesc')}</p>
        </div>
        {/* 第二个卡片 */}
        <div className='mt-8 bg-gradient-to-br from-purple-900/30 via-blue-900/20 to-transparent backdrop-blur-xl border border-purple-900 rounded-2xl p-6   shadow-[0_4px_24px_0_rgba(173,80,255,0.8)] md:p-8'>
          <h3 className=' md:text-lg font-semibold text-white mb-4 flex items-center gap-2 font-mono text-lg'>
            <div className='w-1.5 h-1.5 bg-blue-400 rounded-full '></div>
            {t('home.coreValuesTitle')}
          </h3>
          <div className='pl-4 border-l-2 border-purple-500/20 mb-3'>
            <div className='font-semibold text-white text-sm md:text-base'>{t('home.synergyTitle')}</div>
            <div className='text-gray-300/90 text-sm'>{t('home.synergyDesc')}</div>
          </div>
          <div className='pl-4 border-l-2 border-blue-500/20 mb-3'>
            <div className='font-semibold text-white text-sm md:text-base'>{t('home.industryTitle')}</div>
            <div className='text-gray-300/90 text-sm'>{t('home.industryDesc')}</div>
          </div>
          <div className='pl-4 border-l-2 border-cyan-500/20 mb-3'>
            <div className='font-semibold text-white text-sm md:text-base'>{t('home.trustFutureTitle')}</div>
            <div className='text-gray-300/90 text-sm'>{t('home.trustFutureDesc')}</div>
          </div>
        </div>
        {/* 第三个卡片 */}
        <div className='mt-8 bg-gradient-to-br from-purple-900/30 via-blue-900/20 to-transparent backdrop-blur-xl border border-purple-900 rounded-2xl p-6  shadow-[0_4px_24px_0_rgba(173,80,255,0.8)] md:p-8 '>
          <h3 className='font-mono text-lg md:text-lg font-semibold text-white mb-4 flex items-center gap-2'>
            <div className='w-1.5 h-1.5 bg-cyan-400 rounded-full'></div>
            {t('home.futureVisionTitle')}
          </h3>
          <div className='  text-xs  text-gray-300/80 leading-relaxed mb-3 md:text-sm'>
            <div className='flex items-start pb-2'><span className='text-purple-400 mr-4'  >●</span><span>{t('home.vision1')}</span></div>
            <div className='flex items-start pb-2'><span className='text-blue-400 mr-4 '>●</span><span>{t('home.vision2')}</span></div>
            <div className='flex items-start pb-2'><span className='text-cyan-400 mr-4 '>●</span><span>{t('home.vision3')}</span></div>
            <div className='flex items-start pb-2'><span className='text-indigo-400 mr-4 '>●</span><span>{t('home.vision4')}</span></div>
          </div>

          <div className='flex items-center  mt-2  border-t border-white/6 pt-4'>
            <div className='flex items-center mr-3'>
              <div className='w-2 h-2 bg-purple-400 rounded-full animate-pulse mr-2'></div>
              <span className='text-xs text-purple-300/70'>BlockChain</span>
            </div>
            <div className='flex items-center mr-3'>
              <div className='w-2 h-2 bg-blue-400 rounded-full animate-pulse mr-2' style={{ animationDelay: '0.5s' }}></div>
              <span className='text-xs text-blue-300/70'>AI</span>
            </div>
            <div className='flex items-center '>
              <div className='w-2 h-2 bg-cyan-400 rounded-full animate-pulse mr-2' style={{ animationDelay: '1s' }}></div>
              <span className='text-xs text-cyan-300/70'>RWA</span>
            </div>
          </div>
        </div>
        {/* 第四个卡片 */}
        <div className='mt-8 bg-gradient-to-br from-purple-900/30 via-blue-900/20 to-transparent backdrop-blur-xl border border-purple-900 rounded-2xl p-6  shadow-[0_4px_24px_0_rgba(173,80,255,0.8)] md:p-8 '>
          <div className='mb-3 '>
            <div className='w-14 h-1 rounded-full bg-gradient-to-r from-purple-400 to-cyan-400 mb-3'></div>
            <h4 className='font-mono text-lg md:text-xl font-semibold text-white'>{t('home.alphaIntroTitle')}</h4>
          </div>
          <p className='text-sm text-gray-300/90 leading-relaxed mb-2'>{t('home.alphaIntroDescShort')}</p>

          <div className='flex items-start mb-2'>
            <div className='min-w-2 h-2 bg-purple-400 rounded-full  mt-1 mr-3 '></div>
            <div className='text-xs text-gray-300/90 leading-relaxed'>{t('home.alphaFeature1')}</div>
          </div>

          <div className='flex items-start mb-2'>
            <div className='min-w-2 h-2 bg-yellow-400 rounded-full  mt-1 mr-3 '></div>
            <div className='text-xs text-gray-300/90 leading-relaxed'>{t('home.alphaFeature2')}</div>
          </div>

          <div className='flex items-start mb-2'>
            <div className='min-w-2 h-2 bg-indigo-400 rounded-full  mt-1 mr-3 '></div>
            <div className='text-xs text-gray-300/90 leading-relaxed'>{t('home.alphaFeature3')}</div>
          </div>

          <div className='flex items-start mb-2'>
            <div className='min-w-2 h-2 bg-pink-400 rounded-full  mt-1 mr-3 '></div>
            <div className='text-xs text-gray-300/90 leading-relaxed'>{t('home.alphaFeature4')}</div>
          </div>

          <div className='flex items-start mb-2'>
            <div className='min-w-2 h-2 bg-cyan-400 rounded-full  mt-1 mr-3 '></div>
            <div className='text-xs text-gray-300/90 leading-relaxed'>{t('home.alphaFeature5')}</div>
          </div>

          {/* <div className='flex items-start mb-2'>
            <div className='min-w-2 h-2 bg-green-400 rounded-full  mt-1 mr-3  '></div>
            <div className='text-xs text-gray-300/90 leading-relaxed'>{t('home.alphaFeature6')}</div>
          </div> */}
        </div>
      </div>
      {/* 第四部分 */}
      <div className=' relative mx-10 mt-8  bg-gradient-to-br from-purple-900/30 via-blue-900/20 to-transparent border border-purple-900 rounded-2xl p-6  shadow-[0_4px_24px_0_rgba(173,80,255,0.8)] md:p-8 md:max-w-[1200px] md:mx-auto'>
        {/* 角落装饰 */}
        <img src={bg7} className='absolute -right-0 -top-0 opacity-50' alt="" />
        <img src={bg10} className='absolute -left-0 -top-0 opacity-50' alt="" />
        <img src={bg11} className='absolute -left-0 -bottom-0 opacity-50' alt="" />
        <img src={bg12} className='absolute -right-0 -bottom-0 opacity-50' alt="" />

        <div className='flex items-center  mb-6 md:mb-8'>
          <div className='w-1 h-6 bg-gradient-to-b from-purple-500 to-cyan-500 rounded-full md:h-8  mr-3'></div>
          <h3 className='text-lg md:text-xl lg:text-2xl font-mono font-semibold text-transparent bg-gradient-to-r text-white'>
            {t('home.contractHashPower')}
          </h3>
        </div>

        <div >
          {/* 表头 */}
          <div className='mb-2 flex items-center justify-between bg-gradient-to-r from-purple-500/10 to-blue-500/10 border border-purple-500/20 rounded-lg px-3   md:px-8 py-4 md:py-5'>
            <div className='w-[40%] text-xs md:text-sm font-medium text-purple-300 flex items-center text-center'>   {t('home.contractHashPowerLabel')}<br />(NFX)</div>
            <div className='w-[30%] text-center text-xs md:text-sm font-medium text-blue-300'>{t('home.stakingPeriod')}</div>
            <div className='w-[30%] text-right text-xs md:text-sm font-medium text-cyan-300'>{t('home.hashPowerRate')}</div>
          </div>

          {/* 表格行 */}
          {contractPowerData.map((item, index) => (
            <div
              key={index}
              className='mb-2 flex items-center justify-between bg-white/[0.02] hover:bg-white/[0.05] border border-white/10 hover:border-purple-500/30 rounded-lg  px-3 md:px-8 py-4 md:py-5 transition-all duration-300 '
              style={{ animation: `slideInRight 0.5s ease-out ${index * 0.1}s both` }}
            >
              <div className='w-[40%] text-xs md:text-sm text-gray-300 group-hover/row:text-white transition-colors'>{item.monthly}</div>
              <div className='w-[30%] text-center text-xs md:text-sm text-blue-400 group-hover/row:text-blue-300 transition-colors'>{item.range}</div>
              <div className='w-[30%] text-right text-xs md:text-sm text-cyan-400 group-hover/row:text-cyan-300 transition-colors'>{item.yearly}</div>
            </div>
          ))}
        </div>
      </div>
      {/* 第五部分 */}
      <RosePieChart />

      {/* 第六部分 */}
      <div className='relative pt-12 md:py-16 lg:py-20  md:mb-16 lg:mb-20 overflow-hidden'>
        {/* 标题 */}
        <div className='max-w-[1200px] lg:max-w-[1400px] xl:max-w-[1600px] mx-auto px-10 md:px-16 lg:px-24 xl:px-28 mb-8 md:mb-12'>
          <div className='flex items-center gap-3'>
            <div className='w-1 h-6 md:h-8 bg-gradient-to-b from-purple-500 to-cyan-500 rounded-full'></div>
            <h2 className='text-lg md:text-xl lg:text-2xl font-mono font-semibold text-transparent bg-gradient-to-r text-white '>
              {t('home.roadmapTitle')}
            </h2>
          </div>
        </div>
        {/* 路线图容器 */}
        <div className='relative'>
          {/* 左右渐变遮罩 */}
          <div className='absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-black/50 to-transparent z-10 xl:hidden pointer-events-none'></div>
          <div className='absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-black/50 to-transparent z-10 xl:hidden pointer-events-none'></div>

          <div ref={scrollRef} className='overflow-x-auto pt-5 pb-2 scrollbar-none flex xl:justify-center'>
            <div className='flex relative group'>
              {/* 路线图主体 - 添加发光效果 */}
              <div className='relative'>
                <div className='absolute -inset-2 bg-gradient-to-r  rounded-lg blur-xl opacity-0 transition-opacity duration-700'></div>
                <img src={bg18} className='relative w-[1200px] min-w-[1200px] flex-shrink-0 drop-shadow-2xl' alt="" />
              </div>
              <div>
                <div className={`absolute ${language !== 'zh' ? 'left-[105px]' : 'left-[98px]'}  top-[2px] font-semibold`}>
                  {t('home.phase1')}
                </div>
                <ul className={`list-disc pl-4 absolute  ${leftpx[0][language as 'zh' | 'en']}  bottom-[40px] tracking-[1px] leading-5  text-ad  text-xs`}>
                  <li>{t('home.phase1Item1')}</li>
                  <li>{t('home.phase1Item2')}</li>
                </ul>
                <div className={`absolute  ${language !== 'zh' ? 'left-[275px]' : 'left-[268px]'}  bottom-[39px] font-semibold text-66`}>
                  {t('home.phase2')}
                </div>
                <ul className={`list-disc pl-4 absolute ${leftpx[1][language as 'zh' | 'en']} top-[-5px] tracking-[1px] leading-5 text-xs text-ad`}>
                  <li>{t('home.phase2Item1')}</li>
                  <li>{t('home.phase2Item2')}</li>
                  <li>{t('home.phase2Item3')}</li>
                </ul>

                <div className={`absolute ${language !== 'zh' ? 'left-[453px]' : 'left-[444px]'} top-[2px] font-semibold `}>
                  {t('home.phase3')}
                </div>

                <ul className={`list-disc pl-4 absolute ${leftpx[2][language as 'zh' | 'en']}  bottom-[40px] tracking-[1px] leading-5 text-xs text-ad`}>
                  <li>{t('home.phase3Item1')}</li>
                  <li>{t('home.phase3Item2')}</li>
                </ul>

                <div className={`absolute  ${language !== 'zh' ? 'left-[645px]' : 'left-[637px]'}  bottom-[39px] font-semibold text-66`}>
                  {t('home.phase4')}
                </div>
                <ul className={`list-disc pl-4 absolute ${leftpx[3][language as 'zh' | 'en']}  top-[20px] tracking-[1px] leading-5 text-xs text-ad`}>
                  <li>{t('home.phase4Item1')}</li>
                  <li>{t('home.phase4Item2')}</li>
                </ul>

                <div className={`absolute  ${language !== 'zh' ? 'left-[820px]' : 'left-[810px]'}  top-[2px] font-semibold`}>
                  {t('home.phase5')}
                </div>
                <ul className={`list-disc pl-4 absolute ${leftpx[4][language as 'zh' | 'en']}  bottom-[20px] tracking-[1px] leading-5 text-xs text-ad`}>
                  <li>{t('home.phase5Item1')}</li>
                  <li>{t('home.phase5Item2')}</li>
                  <li>{t('home.phase5Item3')}</li>
                </ul>
                <div className={`absolute   ${language !== 'zh' ? 'right-[175px]' : 'right-[165px]'}  bottom-[39px] font-semibold text-66 `}>
                  {t('home.phase6')}
                </div>
                <ul className={`list-disc pl-4 absolute ${leftpx[5][language as 'zh' | 'en']}   -top-[5px] tracking-[1px] leading-5 text-xs text-ad`}>
                  <li>{t('home.phase6Item1')}</li>
                  <li>{t('home.phase6Item2')}</li>
                  <li>{t('home.phase6Item3')}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>


      {/* 第七部分 */}
      <div className='relative pt-12 md:py-16 lg:py-20  overflow-hidden'>
        {/* 背景装饰 */}
        <div className='absolute inset-0 bg-gradient-to-br from-purple-900/10 via-transparent to-blue-900/10'></div>
        <div className='absolute bottom-0 right-0 w-96 h-96 bg-purple-500/10 rounded-full blur-[150px]'></div>

        <div className='relative max-w-[1200px] lg:max-w-[1400px] xl:max-w-[1600px] mx-auto px-10 md:px-16 lg:px-24 xl:px-28'>
          {/* 标题 */}
          <div className='flex items-center justify-center gap-3 mb-8 md:mb-10'>
            <div className='w-1 h-6 md:h-8 bg-gradient-to-b from-purple-500 to-cyan-500 rounded-full'></div>
            <h2 className='text-lg md:text-xl lg:text-2xl font-mono font-semibold text-transparent bg-gradient-to-r text-white bg-clip-text'>
              {t('home.partners')}
            </h2>
            <div className='w-1 h-6 md:h-8 bg-gradient-to-b from-cyan-500 to-purple-500 rounded-full'></div>
          </div>
          <div className='grid grid-cols-2 md:grid-cols-2 gap-4 md:gap-6 lg:gap-8 max-w-2xl mx-auto'>
            {
              logo.map((logoItem, index) => (
                <div
                  key={index}
                  className={`relative bg-white/[0.02] hover:bg-white/[0.05] border border-white/10 rounded-lg w-full h-16 md:h-20 lg:h-24 flex items-center px-2  transition-all duration-300 shadow-[0_24px_48px_rgba(0,0,0,0.25),0_6px_18px_rgba(0,0,0,0.12),0_0_40px_rgba(255,255,255,0.04)]`}
                  style={{ animation: `fadeInUp 0.5s ease-out ${index * 0.08}s both` }}
                >
                  <div className='flex items-center'>
                    <img src={logoItem.img} alt="" className={`w-10  min-w-10 transition-all duration-300 mr-1 md:w-16 md:mr-3 `} />
                    <p className={`text-xs md:text-lg ${logoItem.w}`}>{logoItem.value}</p>

                  </div>

                  {/* 悬浮光效 */}
                  <div className='absolute inset-0 bg-gradient-to-br from-purple-500/0 via-blue-500/0 to-cyan-500/0 rounded-lg transition-all duration-500'></div>

                  {/* 底部阴影（静态） */}
                  <div className='absolute -bottom-2 left-1/2 -translate-x-1/2 w-3/4 h-2 bg-purple-500/5 blur-lg rounded-full transition-all duration-300'></div>
                </div>
              ))
            }
          </div>
        </div>
      </div>

      {/* 第八部分  底部跳转图标*/}
      <div className='py-12 mx-10 md:mx-auto max-w-[1200px]'>
        <div className='flex items-center justify-center ' >
          <div onClick={() => { window.location.href = CONTACT_LINK.officialWebsite }} className='mr-3 border border-white rounded-full w-9 h-9 flex items-center  justify-center hover:border-d5a hover:text-d5a'><Icon className='w-6' src={earth} /></div>
          <div onClick={() => { window.location.href = CONTACT_LINK.twitter }} className='mr-3 border border-white rounded-full w-9 h-9 flex items-center justify-center hover:border-d5a hover:text-d5a'> <XOutlined /></div>
          <div onClick={() => { window.location.href = CONTACT_LINK.telegram }} className='mr-3 border border-white rounded-full w-9 h-9 flex items-center  justify-center hover:border-d5a hover:text-d5a'><Icon className='w-6' src={telegram} /></div>
          <div onClick={() => { window.location.href = CONTACT_LINK.discord }} className='mr-3 border border-white rounded-full w-9 h-9 flex items-center justify-center text-xl hover:border-d5a hover:text-d5a'><DiscordOutlined /></div>
        </div>
      </div>
    </ScrollView>
  )
}

export default Home

